import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import { Route, Switch } from "react-router-dom";
import Event from "components/event/Event";
import Dashboard from "components/dashboard/Dashboard";
import NotFound from "components/NotFound";
import Header from "components/header/Header";
import AllEvents from "components/event/AllEvents";
import EditPage from "components/modify/EditPage";
import CreatePage from "components/modify/CreatePage";
import Dns from "components/memes/Dns";
import LoginPage from "components/user/LoginPage";
import LogoutPage from "components/user/LogoutPage";
import MyEventsPage from "components/user/MyEventsPage";
import Raffle from "components/raffle/Raffle";
import FaqPage from "components/faq/FaqPage";

const Routes = ({ signedIn }) => {
  return (
    <>
      <Header />
      <Switch>
        {paths
          .filter(({ excludeOnLoggedOut }) => {
            if (excludeOnLoggedOut && !signedIn) {
              return false;
            }
            return true;
          })
          .filter(({ excludeOnLoggedIn }) => {
            if (excludeOnLoggedIn && signedIn) {
              return false;
            }
            return true;
          })
          .map(({ key, path, component, exact }) => (
            <Route key={key} path={path} exact={exact} component={component} />
          ))}
      </Switch>
    </>
  );
};

export const paths = [
  {
    key: "home",
    exact: true,
    path: "/",
    component: Dashboard,
  },
  {
    key: "Login",
    path: "/login",
    excludeOnLoggedIn: true,
    component: LoginPage,
  },
  {
    key: "Logout",
    path: "/logout",
    excludeOnLoggedOut: true,
    component: LogoutPage,
  },
  {
    key: "events",
    path: "/events/:id",
    component: Event,
  },
  {
    key: "allEvents",
    path: "/events",
    component: AllEvents,
  },
  {
    key: "myEvents",
    path: "/myevents",
    excludeOnLoggedOut: true,
    component: MyEventsPage,
  },
  {
    key: "EditPage",
    path: "/edit/:id",
    excludeOnLoggedOut: true,
    component: EditPage,
  },
  {
    key: "CreatePage",
    path: "/create/new",
    excludeOnLoggedOut: true,
    component: CreatePage,
  },
  {
    key: "DNS",
    path: "/dns",
    component: Dns,
  },
  {
    key: "Raffle",
    path: "/raffle/:id",
    excludeOnLoggedOut: true,
    component: Raffle,
  },
  //commented out until completed
  {
    key: "FAQ",
    path: "/faq",
    component: FaqPage,
  },
  {
    key: "NotFound",
    component: NotFound,
  },
];

const mapStateToProps = (state) => ({
  signedIn: get(state, "rootReducer.core.user.signedIn"),
});

export default connect(mapStateToProps, null)(Routes);
